import $ from "/srv/www/f/friesland-boating.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";
import Isotope from "/srv/www/f/friesland-boating.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/isotope-layout";

$(document).ready(() => {
  const $container = $(".ms_boat-filter .boats");
  const filters = {};
  let totalAmountOfPersons = 2;
  let comboFilter;
  let i = 0;

  if ($container.length) {
    new Isotope('.ms_boat-filter .boats', {
      itemSelector: ".filter-boat-card",
      filter: multipleFilter
    });

    // Create filters when checkboxes change.
    $(".ms_boat-filter [data-slider]").on("moved.zf.slider", () => {
      // Change the comparator for the range slider.
      totalAmountOfPersons = +$("#selectedValue").val();
      // Increase value so we can check if the user has checked a checkbox.
      i++;
      new Isotope('.ms_boat-filter .boats', {
        filter: multipleFilter
      });
    });

    // Create filters when checkboxes change.
    const $checkboxes = $(".filter .checkboxes input");
    $checkboxes.on("change", ({ target }) => {
      // Increase value so we can check if the user has moved the range slider.
      i++;
      const $checkbox = $(target);
      manageCheckbox($checkbox);
      comboFilter = getComboFilter(filters);
      new Isotope('.ms_boat-filter .boats', {
        filter: multipleFilter
      });
    });

    function multipleFilter() {
      const item = $(this);
      // Check if selected range value is between min and max of an item.
      function checkValue() {
        const min = item.attr("data-min-persons");
        const max = item.attr("data-max-persons");
        const isInPersonsRange =
          totalAmountOfPersons >= min && totalAmountOfPersons <= max;
        return isInPersonsRange;
      }

      // Show all items when totalAmountOfPersons is 2.
      if (totalAmountOfPersons === 2) {
        console.log(totalAmountOfPersons, comboFilter || "*");
        return item.is(comboFilter || "*");
      }

      console.log('normal ', checkValue(), item.is(comboFilter || "*"));

      // Show or do not show item based on conditions.
      return checkValue() && item.is(comboFilter || "*");
    }

    function getComboFilter(filters) {
      let combo = [];
      for (const prop in filters) {
        const group = filters[prop];
        if (!group.length) {
          // No filters in the group, so continue.
          continue;
        }
        // Add first group.
        if (!combo.length) {
          combo = group.slice(0);
          continue;
        }
        // Add additional groups.
        const nextCombo = [];
        // Split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
        for (let i = 0; i < combo.length; i++) {
          for (let j = 0; j < group.length; j++) {
            const item = combo[i] + group[j];
            nextCombo.push(item);
          }
        }
        combo = nextCombo;
      }
      const comboFilter = combo.join(", ");
      return comboFilter;
    }

    function manageCheckbox($checkbox) {
      const checkbox = $checkbox[0];
      const group = $checkbox.parents(".options").attr("data-group");
      // Create array for filter group, if not there yet.
      let filterGroup = filters[group];
      if (!filterGroup) {
        filterGroup = filters[group] = [];
      }

      const index = $.inArray(checkbox.value, filterGroup);
      if (checkbox.checked) {
        // Check if index is not yet in group.
        if (index === -1) {
          // Add filter to group.
          filters[group].push(checkbox.value);
        }
      } else {
        // Remove filter from group.
        filters[group].splice(index, 1);
      }
    }
  }
});
